<template>
  <div class="bg-white px-4 lg:px-12 sticky top-0 border-b z-10">
    <nav class="text-sm max-w-7xl mx-auto">
      <RouterLink
        :to="{ name: 'accounts.projects.project.settings' }"
        class="px-4 inline-flex h-12 items-center justify-center"
        :class="[
          $route.name === 'accounts.projects.project.settings'
            ? 'text-blue-600 bg-gray-200'
            : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
        ]"
      >
        General
      </RouterLink>

      <RouterLink
        v-if="$membershipHasPermissionTo('read projects')"
        :to="{ name: 'accounts.projects.project.accountsParticipating' }"
        class="px-4 inline-flex h-12 items-center justify-center"
        :class="[
          $route.name === 'accounts.projects.project.accountsParticipating'
            ? 'text-blue-600 bg-gray-200'
            : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
        ]"
      >
        Accounts Participating
      </RouterLink>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
};
</script>
